import { Alert, Box, Button, Modal, TextField, Typography } from '@mui/material';
import { useState } from 'react';

interface PasswordChangeModalProps {
  open: boolean;
  onClose: () => void;
}

export default function PasswordChangeModal({ open, onClose }: PasswordChangeModalProps) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [successMessage, setSuccessMessage] = useState(false); // 성공 메시지 상태를 boolean으로 변경

  const [passwordTouched, setPasswordTouched] = useState(false);
  const [passwordAlert, setPasswordAlert] = useState(true);
  const [errormsg, setErrormsg] = useState('');
  const [confirmPasswordAlert, setConfirmPasswordAlert] = useState(true);

  const boxStyle = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px'
  };

  const handleCloseAndReset = () => {
    setErrormsg('');
    setSuccessMessage(false); // 성공 메시지 상태 초기화
    setNewPassword('');
    setConfirmPassword('');
    onClose();
  };

  const handlePasswordChange = async () => {
    if (newPassword !== confirmPassword) {
      setErrormsg('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      // const result = await putUserIdPasswordAPI({ ... });
      setSuccessMessage(true); // 성공 시 상태 업데이트
    } catch (error) {
      console.error('Error:', error);
      setErrormsg('비밀번호 변경에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleConfirmPasswordBlur = () => {
    setPasswordTouched(true);
    setConfirmPasswordAlert(newPassword === confirmPassword);
  };

  return (
    <Modal open={open} onClose={handleCloseAndReset}>
      <Box sx={boxStyle}>
        {!successMessage ? (
          <>
            <Typography variant="h6" component="h2" gutterBottom>
              비밀번호 변경
            </Typography>
            {errormsg && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {errormsg}
              </Alert>
            )}
            <Box display="flex" flexDirection="column" gap={1} mt={4}>
              <Box display="flex" flexDirection="row" alignItems="start" gap={1}>
                <Typography width={80} variant="caption" color="#7f7f7f" height={32} lineHeight={2.75}>
                  새 비밀번호
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  size="small"
                  variant="outlined"
                  placeholder="새 비밀번호를 입력해주세요."
                  onBlur={() => setPasswordTouched(true)}
                  error={passwordTouched && !passwordAlert}
                  helperText={passwordTouched && !passwordAlert ? '영문, 숫자, 특수문자를 각 1개씩 포함하여 8~32자리이어야 합니다.' : null}
                  sx={{
                    flexGrow: 1,
                    width: '100px',
                    '& .MuiInputBase-root': { height: '32px', borderRadius: '4px' },
                    '& input': { height: '32px', fontSize: '0.75rem', padding: '0 8px' },
                    '& .MuiFormHelperText-root': { marginX: '8px' }
                  }}
                />
              </Box>
              <Box display="flex" flexDirection="row" alignItems="start" gap={1}>
                <Typography width={80} variant="caption" color="#7f7f7f" height={32} lineHeight={2.75}>
                  새 비밀번호 확인
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  size="small"
                  variant="outlined"
                  placeholder="새 비밀번호를 다시 입력해주세요."
                  onBlur={handleConfirmPasswordBlur}
                  error={passwordTouched && !confirmPasswordAlert}
                  helperText={passwordTouched && !confirmPasswordAlert ? '비밀번호가 일치하지 않습니다.' : null}
                  sx={{
                    flexGrow: 1,
                    width: '100px',
                    '& .MuiInputBase-root': { height: '32px', borderRadius: '4px' },
                    '& input': { height: '32px', fontSize: '0.75rem', padding: '0 8px' },
                    '& .MuiFormHelperText-root': { marginX: '8px' }
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ mt: 2, textAlign: 'right' }}>
              <Button variant="contained" color="primary" sx={{ mr: 1 }} onClick={handlePasswordChange}>
                변경
              </Button>
              <Button variant="outlined" onClick={handleCloseAndReset}>
                닫기
              </Button>
            </Box>
          </>
        ) : (
          <Box textAlign="center">
            <Typography variant="h6" gutterBottom>
              비밀번호 재설정이 완료되었습니다.
            </Typography>
            <Typography variant="body1" gutterBottom>
              새로운 비밀번호로 로그인해서 <br />
              서비스를 이용하시기 바랍니다.
            </Typography>
            <Box sx={{ px: '24px', pb: '24px', pt: 2 }}>
              <Button
                variant="contained"
                size="medium"
                color="primary"
                fullWidth
                onClick={handleCloseAndReset}
                sx={{ borderRadius: '4px', fontWeight: 'bold' }}
              >
                로그인 하기
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
}
